import { Component, inject } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { MenuStore } from './menu.store';
import { NgClass } from '@angular/common';
import { MenuPipe } from './menu.pipe';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrl: 'menu.component.scss',
    providers: [MenuStore],
    imports: [
        NgClass,
        MenuPipe,
        MenuItemComponent,
    ],
})
export class MenuComponent {
    protected readonly store = inject(MenuStore);
    protected readonly layoutService = inject(LayoutService);
}
